import img from '../../../images/projects/dés-aventures.png'
import { useEffect } from 'react';

import paths from '../../../config/paths'

export default function DesAventures({ visited }) {

    useEffect(() => {
        visited();
    }, []);

    return(
        <main className="relative flex flex-col justify-evenly">
            <div className='video'>
                <img src={img}></img>
            </div>
            <h2 className='title'>Dés Aventures</h2>
            <p className='content'>Dés Aventures est un des premiers projets que j'ai fait. Il fallait faire un site vitrine pour une association.</p>
            <p className='skills'>HTML/CSS | Bootstrap | Javascript</p>
            <div className='project-button'>
                <a className='website' target="_blank" href="https://des-aventures.netlify.app/">Le site</a>
                <a className='github' target="_blank" href="https://github.com/Coussecousse/Des_aventures"><i className="fa-brands fa-github"></i>Github</a>
            </div>
            <div className='project-button big-buttons'>
                <a href={paths.CHARLES_CANTIN} className='backProject'><i className="fa-solid fa-arrow-left mr-2"></i>Précédent projet</a>
                <a href={paths.PROJECTS} className='backProject'><i className="fa-solid fa-arrow-left mr-2"></i>Revenir aux projets</a>
                <a href={paths.ROLLIN_BATTLE} className='backProject'>Prochain projet<i className="fa-solid fa-arrow-right ml-2"></i></a>
            </div>
        </main>
    )
}